import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Add your contact info or a call to action`}</h2>
    <p>{`Let people know `}<span className="contact-link"><a parentName="p" {...{
          "href": "https://stevenorechow.me/"
        }}>{`how they can work with you`}</a>{` `}</span>{`or add a button so the folks visiting your page can take action.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      